import { LoadableLazy } from '@confluence/loadable';

export const ReverseTrialLozengeExperiment = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ReverseTrialLozengeExperiment" */ '../src/ReverseTrialLozengeExperiment/ReverseTrialLozenge.tsx'
			)
		).ReverseTrialLozengeWithErrorBoundary,
});
